const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonsterSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CC04A"
    },
    d: "M118.596,251.777c-64.609,0-117.173-52.564-117.173-117.172c0-16.138,13.081-29.218,29.218-29.218 c16.136,0,29.217,13.08,29.217,29.218c0,32.387,26.35,58.737,58.738,58.737c16.136,0,29.218,13.082,29.218,29.218 S134.733,251.777,118.596,251.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CC04A"
    },
    d: "M393.397,251.777c-16.137,0-29.217-13.08-29.217-29.216s13.081-29.218,29.217-29.218 c32.388,0,58.737-26.349,58.737-58.737c0-16.138,13.081-29.218,29.217-29.218c16.137,0,29.219,13.08,29.219,29.218 C510.57,199.213,458.006,251.777,393.397,251.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CC04A"
    },
    d: "M480.564,333.671c0.522-3.378,0.796-6.839,0.796-10.365c0-32.504-23.038-59.623-53.676-65.924 c0.009-0.462,0.035-0.919,0.035-1.383c0-24.466-13.056-45.879-32.579-57.663c0.452-3.15,0.698-6.368,0.698-9.641 c0-29.01-18.354-53.73-44.081-63.189c0.083-1.363,0.137-2.736,0.137-4.118c0-37.169-30.133-67.302-67.304-67.302h-57.178 c-37.171,0-67.304,30.133-67.304,67.302c0,1.383,0.055,2.754,0.137,4.118c-25.729,9.458-44.081,34.179-44.081,63.189 c0,3.274,0.246,6.493,0.699,9.641C97.34,210.121,84.283,231.534,84.283,256c0,0.464,0.027,0.921,0.035,1.383 c-30.638,6.3-53.676,33.421-53.676,65.924c0,3.524,0.274,6.986,0.796,10.365C12.553,345.59,0,366.628,0,390.611 c0,37.169,30.133,67.302,67.304,67.302h377.392c37.171,0,67.304-30.133,67.304-67.302C512,366.628,499.448,345.59,480.564,333.671z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 460.37,
    cy: 381.562,
    r: 18.222
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 255.994,
    cy: 191.952,
    r: 72.027
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7F3F"
    },
    cx: 255.994,
    cy: 191.952,
    r: 33.566
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M356.801,298.51h-30.917v26.471c0,11.906-9.653,21.56-21.561,21.56 c-11.908,0-21.561-9.652-21.561-21.56V298.51h-63.261c0,11.908-9.653,21.561-21.561,21.561c-11.907,0-21.562-9.652-21.562-21.561 h-21.191c-11.868,0-12.916,6.969-12.603,10.394c5.254,58.021,54.025,103.486,113.413,103.486 c59.387,0,108.158-45.465,113.412-103.486C369.718,305.479,368.67,298.51,356.801,298.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M431.713,307.566c-0.001-5.006-4.056-9.055-9.056-9.055 c-4.998-0.002-9.054,4.049-9.054,9.057c-0.002,4.997,4.052,9.053,9.053,9.053C427.657,316.623,431.713,312.563,431.713,307.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M76.262,390.611c-0.001-5.006-4.056-9.055-9.056-9.055 c-4.998-0.002-9.054,4.049-9.054,9.057c-0.002,4.997,4.052,9.05,9.053,9.05C72.206,399.668,76.263,395.609,76.262,390.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M146.31,258c-0.001-5.006-4.056-9.055-9.056-9.055 c-4.998-0.002-9.054,4.049-9.054,9.057c-0.002,4.997,4.052,9.053,9.053,9.053C142.255,267.057,146.311,262.997,146.31,258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M307.672,95.302c-0.001-5.006-4.056-9.055-9.056-9.055 c-4.998-0.002-9.054,4.049-9.054,9.057c-0.002,4.997,4.052,9.053,9.053,9.053C303.616,104.36,307.673,100.301,307.672,95.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M365.883,263.97c-0.001-5.006-4.056-9.055-9.056-9.057 c-4.997-0.002-9.054,4.051-9.053,9.057c-0.002,5,4.052,9.053,9.053,9.053C361.827,273.025,365.884,268.965,365.883,263.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M360.949,421.448c-0.001-5.006-4.056-9.055-9.056-9.057 c-4.997-0.002-9.054,4.051-9.053,9.057c-0.002,5,4.052,9.053,9.053,9.053C356.893,430.503,360.949,426.443,360.949,421.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M404.892,372.501c-0.001-5.006-4.056-9.055-9.056-9.055 c-4.998-0.002-9.054,4.049-9.054,9.057c-0.002,4.997,4.052,9.053,9.053,9.053C400.837,381.559,404.892,377.499,404.892,372.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M395.838,237.517c-0.001-5.006-4.056-9.055-9.056-9.057 c-4.998-0.002-9.054,4.051-9.054,9.057c-0.002,5,4.052,9.053,9.053,9.053C391.782,246.572,395.838,242.512,395.838,237.517z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterSvgrepoCom);
export default __webpack_public_path__ + "static/media/monster-svgrepo-com.ae65d28f5d3e983151aab90c7560957f.svg";
export { ForwardRef as ReactComponent };